import {
  SpreadsheetDocumentsData,
  parseSpreadsheetDocuments,
} from '../models/SpreadsheetDocument';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';

/**
 * 자재 스프레드시트 API 클라이언트 (다중 문서).
 *
 * IP/네트워크 스프레드시트와 동일 패턴 — projects.material_spreadsheet JSON 컬럼에
 * 통째로 저장. 업로드한 엑셀 1개 = 문서 1개로 관리한다.
 * (구조화 자재 테이블 SiteMaterialService 와는 별개 — 대시보드 요약 위젯은 그쪽을 본다.)
 */

/** 자재 문서 기본 컬럼 — 신규 현장 첫 로드 / "빈 문서" seed 에 사용. */
export const DEFAULT_MATERIAL_COLUMNS: ReadonlyArray<{ name: string; width: number }> = [
  { name: '분류', width: 140 },
  { name: '품명', width: 200 },
  { name: '수량', width: 100 },
  { name: '단위', width: 80 },
  { name: '제품업체', width: 160 },
  { name: '비고', width: 200 },
];

const MATERIAL_DOC_NAME = '자재';

interface SpreadsheetApiResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export class MaterialSpreadsheetService {
  static async get(projectId: number): Promise<SpreadsheetDocumentsData> {
    const response = await apiClient.get<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.MATERIAL_SPREADSHEET.GET(projectId),
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 조회 실패');
    }
    return parseSpreadsheetDocuments(response.data.data, {
      defaultDocName: MATERIAL_DOC_NAME,
      defaultColumns: DEFAULT_MATERIAL_COLUMNS,
    });
  }

  static async update(projectId: number, data: SpreadsheetDocumentsData): Promise<void> {
    const response = await apiClient.put<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.MATERIAL_SPREADSHEET.UPDATE(projectId),
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 저장 실패');
    }
  }
}
